import { useEffect, useState } from "react";
import { api } from "./api";

// Store partagé léger pour l'état crédits/quota IA — une seule source de vérité,
// rafraîchie par l'événement global "credits:update" émis après chaque action IA.
let cache = null;
const listeners = new Set();

export function refreshCredits() {
  api.get("/credits").then((r) => {
    cache = r.data;
    listeners.forEach((l) => l(cache));
  }).catch(() => {});
}

export function useCredits() {
  const [state, setState] = useState(cache);
  useEffect(() => {
    const listener = (s) => setState(s);
    listeners.add(listener);
    if (!cache) refreshCredits();
    const handler = () => refreshCredits();
    window.addEventListener("credits:update", handler);
    return () => {
      listeners.delete(listener);
      window.removeEventListener("credits:update", handler);
    };
  }, []);
  return state;
}
